import { createAction, props } from '@ngrx/store';
import { ProjektItem } from '../../projekt.model';
import {NodeItem} from "../../node.model";

export const deleteProjektStart = createAction('PROJEKTKVERWALTUNG::DELETE_PROJEKT_START', props<{ item: NodeItem }>());
export const deleteProjektSucceeded = createAction(
    'PROJEKTKVERWALTUNG::DELETE_PROJEKT_SUCCEEDED'
);
export const deleteProjektFailed = createAction('PROJEKTKVERWALTUNG::DELETE_PROJEKT_FAILED', props<{ error: Error }>());
